import Axios from './axios-service';

const keyCache = new Map();
const pendingRequests = new Map();

const fetchKey = async (keyName) => {
  if (keyCache.has(keyName)) return keyCache.get(keyName);

  if (pendingRequests.has(keyName)) {
    return pendingRequests.get(keyName);
  }

  const request = Axios.get(`/api/getApiKey?key=${keyName}`)
    .then((res) => {
      let apiKey;
      if (res && res.apiKey && res.apiKey != null) {
        apiKey = res.apiKey;
      } 

      keyCache.set(keyName, apiKey);
      pendingRequests.delete(keyName);
      return apiKey;
    })
    .catch((err) => {
      pendingRequests.delete(keyName);
      console.error(`Failed to fetch API key: ${keyName}`, err);
      throw err;
    });

  pendingRequests.set(keyName, request);
  return request;
};

const getCachedKey = (keyName) => {
  const val = keyCache.get(keyName);
  return val === undefined ? null : val;
};

// Public-safe keys only
export const getStripeKey = () => fetchKey('STRIPE_KEY');
export const getGoogleMapsApiKey = () => fetchKey('GOOGLE_MAPS_API_KEY');

export const getCachedStripeKey = () => getCachedKey('STRIPE_KEY');
export const getCachedGoogleMapsApiKey = () => getCachedKey('GOOGLE_MAPS_API_KEY');
  